export interface Product {
    ndcNumber?: string;
    shortName: string;
    name?: string;
    manufacturerName: string;
}

export enum TENANT_STATUS {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}

export enum TENANT_COLORS {
    PURPLE = 'Purple',
    BLUE = 'Blue',
    GREEN = 'Green',
}

export interface TenantAvailableDatapoints {
    patientName: boolean;
    patientDateOfBirth: boolean;
    inventoryName: boolean;
    quickStart: boolean;
    bridge: boolean;
    hubId: boolean;
}

export interface Tenant {
    id: number;
    name: string;
    externalId: string;
    address: string;
    city: string;
    country: string;
    status: TENANT_STATUS;
    postalCode: string;
    email: string;
    subdomainName: string;
    phoneNumber: string;
    isMaster: boolean;
    isLocked: boolean;
    products: Array<Product>;
    coloringScheme: TENANT_COLORS;
    logoId: string;
    logoDataUriContent?: string;
    availableDataPoints: TenantAvailableDatapoints;
}

export interface GetTenantsResponse {
    totalCount: number;
    value: Array<Tenant>;
}

export interface TenantShortInfo {
    coloringScheme: TENANT_COLORS;
    logoDataUriContent: string;
}

export interface TenantInfoBySubdomain {
    id: string;
    name: string;
    subdomain: string;
    organizationId: string;
    status: string;
}
